export default __webpack_public_path__ + "static/media/scadaatech.0e464e83.jpg";